import { ElectricMeter, IElectricMeter } from '@shared/models/electric-meter';
import { Boat, IBoat } from '@shared/models/boat';
import { IReadingRaw, Reading } from './electric-meter-reading';
import { tryParseDate } from '@shared/functions/try-parse-date';
import { BerthBoatAssignment, IBerthBoatAssignment } from '@shared/models/berth-boat-assignment';
import { v4 as uuidv4 } from 'uuid';
import { InvoicePosition, InvoicePositionDto } from '@shared/models/invoice-position';
import { IProduct, Product } from '@shared/models/product';
import { ElectricMeterProductType } from '@shared/models/electric-meter-product-type';

export interface IElectricMeterAssignment {
    id?: number;
    from: string;
    to?: string;
    meterReadingStart: number;
    meterReadingEnd?: number;
    electricMeter?: IElectricMeter;
    boat?: IBoat;
    reading?: IReadingRaw;
    readings?: IReadingRaw[];
    productType: ElectricMeterProductType;
    positions?: InvoicePositionDto[];
    berthAssignment?: IBerthBoatAssignment;
    uuid?: string;
    deleted?: boolean;
    berthAssignmentIndex?: number;

    quantity?: number; // helper property
    product?: IProduct; // helper property
    additionalProduct?: IProduct;
    additionalQuantity?: number;
}

export class ElectricMeterAssignment {
    id?: number;
    from: Date;
    to?: Date;
    meterReadingStart: number;
    meterReadingEnd?: number;
    electricMeter?: ElectricMeter;
    boat?: Boat;
    reading?: Reading;
    readings?: Reading[];
    productType: ElectricMeterProductType;
    positions?: InvoicePosition[];
    berthAssignment?: BerthBoatAssignment;
    uuid: string;
    deleted?: boolean;
    berthAssignmentIndex?: number;

    quantity?: number; // helper property
    product?: Product;
    additionalProduct?: Product;
    additionalQuantity?: number;

    constructor(data = {} as IElectricMeterAssignment) {
        this.id = data.id;
        this.from = tryParseDate(data.from);
        this.to = tryParseDate(data.to);

        this.meterReadingStart = (data.meterReadingStart !== null && data.meterReadingStart !== undefined) ?
            data.meterReadingStart : Math.min(...data.readings?.map(reading => reading.startMeterReading) || [data.reading?.startMeterReading]);

        this.meterReadingEnd = (data.meterReadingEnd !== null && data.meterReadingEnd !== undefined) ?
            data.meterReadingEnd : Math.max(...data.readings?.map(reading => reading.endMeterReading) || [data.reading?.endMeterReading]);

        this.electricMeter = data.electricMeter ? new ElectricMeter(data.electricMeter) : null;
        this.boat = data.boat ? new Boat(data.boat) : null;
        this.reading = data.reading ? new Reading(data.reading) : null;
        this.readings = (data.readings || []).map(reading => new Reading(reading));
        this.productType = data.productType;
        this.positions = (data.positions || []).map(position => new InvoicePosition(position));
        this.berthAssignment = data.berthAssignment ? new BerthBoatAssignment(data.berthAssignment) : null;
        this.uuid = data.uuid || uuidv4();
        this.deleted = data.deleted;
        this.berthAssignmentIndex = data.berthAssignmentIndex;

        this.quantity = data.quantity;
        this.product = data.product ? new Product(data.product) : null;
        this.additionalQuantity = data.additionalQuantity;
        this.additionalProduct = data.additionalProduct ? new Product(data.additionalProduct) : null;
    }
}
